<form [formGroup]="consentForm">
  <div class="container-fluid pt-2 col-sm-8">
    <div class="card">
      <div class="card-header">
        {{ consentName }}
        <span class="float-right">
          <button type="button" (click)="submitForm()"
                  appRequirePermission="admin.all,consent-definition.edit,consent-definition.all"
                  class="btn btn-outline-danger"
                  [disabled]="validateForm()">
            Save
          </button>
        </span>
      </div>
      <div class="card-body">
        <div class="form-group row" *ngIf="isEdit === false">
          <label for="key" class="col-sm-4 control-label">Key<sup class="text-danger">*</sup></label>
          <div class="col-sm-8">
            <input type="text"
                   id="key"
                   class="form-control form-control-sm"
                   formControlName="key">
          </div>
        </div>
        <div class="form-group row">
          <label for="name" class="col-sm-4 control-label">Name<sup class="text-danger">*</sup></label>
          <div class="col-sm-8">
            <input type="text"
                   id="name" [readOnly]="isEdit"
                   class="form-control form-control-sm"
                   formControlName="name">
          </div>
        </div>
        <div class="form-group row">
          <label for="defaultText" class="col-sm-4 control-label">Default text<sup class="text-danger">*</sup></label>
          <div class="col-sm-8">
            <input type="text"
                   class="form-control form-control-sm"
                   id="defaultText"
                   formControlName="defaultText">
          </div>
        </div>
        <div class="form-group row">
          <label for="parentName" class="col-sm-4 control-label">Parent name</label>
          <div class="col-sm-8">
            <input type="text"
                   class="form-control form-control-sm"
                   id="parentName"
                   formControlName="parentName">
          </div>
        </div>

        <div class="form-group row control-label">
          <label class="form-check-label col-sm-4" for="mandatory">
            Mandatory
          </label>
          <div class="form-check col-sm-8">
            <input class="form-check-input ml-1"
                   type="checkbox"
                   id="mandatory"
                   formControlName="mandatory">
          </div>
        </div>
        <div class="form-group row control-label">
          <label class="form-check-label col-sm-4" for="canClientEdit">
            Can client edit
          </label>
          <div class="form-check col-sm-8">
            <input class="form-check-input ml-1"
                   type="checkbox"
                   id="canClientEdit"
                   formControlName="canClientEdit">
          </div>
        </div>
      </div>
    </div>

    <backoffice-monorepo-consent-definition-brand
      [parentForm]="consentForm" [data]="brandAssignmentData"></backoffice-monorepo-consent-definition-brand>


    <div class="card mt-1">
      <div class="card-header">
        Registration steps
        <span class="float-right">
            <select class="form-control form-control-sm ml-2"
                    (change)="addRow(selectFee.value)"
                    #selectFee
                    appRequirePermission="admin.all,consent-definition.edit,consent-definition.all">
              <option value="0">Choose registration type</option>
              <option *ngFor="let key of consentRegistrationTypeOptions" [ngValue]="key" [disabled]="isDisabledType(key)">{{ key }}</option>
            </select>
        </span>
      </div>
      <div class="card-body row" formArrayName="registrationSteps">

        <div class="card m-2 w-25" *ngFor="let group of getFormControls.controls; trackBy: trackBy; let i=index" [formGroupName]="i">
          <div class="card-header">
            <button class="btn btn-danger btn-sm float-right" (click)="deleteRow(i)">Delete</button>
          </div>
          <div class="card-body">
            <div class="input-group mb-3">
              <input type="text" class="form-control" formControlName="consentRegistrationType" [readonly]="true">
            </div>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text">Amount*</span>
              </div>
              <input type="text" class="form-control" formControlName="amount">
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</form>
